import { render } from "./ScheduleGIC.vue?vue&type=template&id=980e95e8"
import script from "./ScheduleGIC.vue?vue&type=script&lang=js"
export * from "./ScheduleGIC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__